/// <amd-module name="Artifacts/Pypi/components/PypiDescription" />
import { PackageTile } from "Artifacts/Package/components/package-details-common/PackageTile";
import * as PackageRes from "Artifacts/Package/Resources";
import * as React from "react";
import * as StringUtils from "VSS/Core/Util/String";
import { MarkdownRendererComponent } from "VSS/Features/Markdown/MarkdownRendererComponent";

export interface IPyPiDescriptionProps {
  description: string;
  contentType: string;
}

export const PypiDescription: React.FC<IPyPiDescriptionProps> = (props) => {
  const isMarkdown =
    props.contentType && StringUtils.equals(props.contentType, "text/markdown", true);

  return (
    <PackageTile
      title={PackageRes.PackageDetails_Description}
      className={"python-package-description"}
    >
      {isMarkdown ? (
        <MarkdownRendererComponent rawContent={props.description} />
      ) : (
        props.description
      )}
    </PackageTile>
  );
};
